/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-13 14:48:52
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-21 10:51:05
 */
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface recentTimeParams {
    current?: number;
    size?: number;
    keyword?: string;
    storehouseId?: number;
    materialsCategory?: number;
    deadlineEnd?: string;
    deadlineStart?: string;
    registrationTimeHead?: string;
    registrationTimeTail?: string;
    _dateRange:any
}

export function recentTimepage(
    params: recentTimeParams
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryledger/deadlinepage`,
        method: "GET",
        params
    }
}
export interface recentTimelogoutlistParams {
    ids: string,state ?:number
}

export function recentTimelogoutlist(
    params: recentTimelogoutlistParams
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryledger/logoutlist`,
        method: "POST",
        params
    }
}